// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */@media (min-width:1024px){.breadCrumbs[data-v-2e5e137e]{margin-bottom:2.4rem}}@media (max-width:1023px){.breadCrumbs[data-v-2e5e137e]{margin-bottom:1.6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
